import { apiClient } from "@/services/api";


const state = () => ({
    configTarjaCronometro: null,
    tarjaParams: null
})

const getters = {
    getConfigTarja: state => {
        return state.configTarjaCronometro
    },
    getTarjaParams: state => {
        return state.tarjaParams
    }
}

const actions = {
    async getConfigTarjaCronometro({ commit }, payload) {
        const { cod_producao } = payload;

        const response = await apiClient.get(`/getProducaoConfigTarjaCronometro/${cod_producao}`)

        if(response.data) {
            commit('setConfigTarjaCronometro', response.data.config)
        }
    },

    assignTarjaParams({ commit }, payload) {
        commit('setTarjaParams', payload)
    }
}

const mutations = {
    setConfigTarjaCronometro(state, payload) {
        state.configTarjaCronometro = payload
    },
    setTarjaParams(state, payload) {
        state.tarjaParams = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}